export default __webpack_public_path__ + "static/media/taskNewActive.e5f5e10e.svg";